package org.tlsys.admin.serialization

import org.tlsys.core.sendAndResive3
import pw.binom.rpc.AbstractRemoteService

object JsInvoker : AbstractRemoteService.Invoker {
    override suspend fun invoke(service: String, method: String, params: Map<String, Any?>): Any? =
        sendAndResive3("$service/$method", params)
}
